import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, inject } from 'intact-vue-next';
import { COLLAPSE } from './index';
import template from './item.vdt';
import { bind } from '../utils';
import { useConfigContext } from '../config';
var typeDefs = {
  value: String,
  title: [String, Object],
  disabled: Boolean
};
export var CollapseItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CollapseItem, _Component);
  function CollapseItem() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.collapse = inject(COLLAPSE);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = CollapseItem.prototype;
  _proto.toggle = function toggle() {
    if (this.get('disabled')) return;
    this.collapse.changeValue(this.get('value'));
  };
  _proto.onEnter = function onEnter() {
    this.trigger('show', this);
  };
  _proto.onAfterLeave = function onAfterLeave() {
    this.trigger('hide', this);
  };
  return CollapseItem;
}(Component);
CollapseItem.template = template;
CollapseItem.typeDefs = typeDefs;
__decorate([bind], CollapseItem.prototype, "toggle", null);